import type { ObjectDirective } from 'vue';

interface Options {
  disabled?: boolean;
}

let directive: ObjectDirective<HTMLElement, Options>;
if (process.env.NODE_ENV === 'production') {
  const contextMenuListener = (e: Event) => {
    e.preventDefault();
  };
  directive = {
    mounted(el: HTMLElement, binding) {
      if (binding.value.disabled) return;
      el.addEventListener('contextmenu', contextMenuListener);
    },
    unmounted(el: HTMLElement) {
      el.removeEventListener('contextmenu', contextMenuListener);
    },
  };
} else {
  directive = {};
}

export default directive;
